import { useEffect } from "react";

import "./Home.css";

import Navbar from "../Navbar/Navbar";
import Hero from "./Components/hero/Hero";
import Stats from "./Components/Stats/Stats";
import Services from "./Components/services/Services";
import Attributes from "./Components/attributes/Attributes";
import Programs from "./Components/programs/Programs";
import Extracurricular from "./Components/extracurricular/Extracurricular";
import Admission from "./Components/admissions/Admission";
import WOrkshop from "./Components/workshop/Workshop";
import Footer from "./Components/footer/Footer";

const Home = () => {

    useEffect(() => {
        if (window.location.hash) {
            const id = window.location.hash.replace("#", "");
            document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
        }
    }, []);


    return (<>

        <Navbar />

        <Hero />

        <Stats />

        <Services />

        <Attributes />

        <Programs />

        <Extracurricular />

        <Admission />

        <WOrkshop />

        <Footer />

    </>)

}

export default Home;